import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions, useRefetchQuery } from "libs/reactQuery";
import toast from "react-hot-toast";

import { requestCreateFeedInsert } from "./createFeedInsert.request";

const useCreateFeedInsert = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  const refetchFeedInserts = useRefetchQuery(["feed-inserts"]);

  return useMutation({
    mutationFn: requestCreateFeedInsert,
    ...options,
    onSuccess: (data, variables, context) => {
      void refetchFeedInserts();
      toast.success("Feed insert created successfully");
      options?.onSuccess?.(data, variables, context);
    }
  });
};

export default useCreateFeedInsert;
